import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';
class ScheduleGradeAlertNotesEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      data: [],
      notes: [],
    };
    //bind específico
    this.add = this.add.bind(this); 
    this.closeModal = this.closeModal.bind(this); 
    this.locale = getLocale();
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  //LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.data.id !== 'undefined' && this.state.loaded === 0) {
        this.setState({
            notes: newProps.data.notes,
            id: newProps.data.id,
            loaded: 1,
        });
    }
    if (newProps.modal === true) {
        this.setState({ modal: true });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_aircraft_staff_alert_id: this.state.id,
      note: this.state.note,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/alerta/comentarios', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.setState({ notes: responseJson.data });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  closeModal(row, event) {
    this.setState({ modal: false, notes: [], loaded: 0 });
    this.props.refreshUpdated();
  }

  
  render() {
    var self = this;
    return (
      <div>
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.GradesDeEscala.GradesDeEscalaAlertas.modal.titulo}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <div>
                <h3 className="page-title">{this.locale.GradesDeEscala.GradesDeEscalaAlertas.modal.tituloComentarios}</h3>
                <hr/>
                <form onSubmit={this.add}>
                    <div className="form-group">
                        <label>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.modal.form.Comentario}:</label>
                        <textarea style={{ height: 100 }} type="text" name="note" className="form-control" placeholder="" value={this.state.note} onChange={this.handleChange.bind(this, 'note')} />
                    </div>
                    <hr/>
                    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
                </form>
                <hr />
                <h3 className="page-title">{this.locale.GradesDeEscala.GradesDeEscalaAlertas.modal.tituloComentariosAlerta}</h3>
                <hr/>
                <div className="table-responsive">
                <table className="table table-bordered table-hover table-striped">
                    <thead>
                        <tr>
                            <th>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.modal.tabela.Autor}</th>
                            <th>{this.locale.GradesDeEscala.GradesDeEscalaAlertas.modal.tabela.Mensagem}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(self.state.notes).map(function(k) {
                            var note = self.state.notes[k];
                            return (
                                <tr>
                                <td>{note.user}</td>
                                <td>{note.note}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                </div>
            </div>


          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ScheduleGradeAlertNotesEditModal;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAlertNotesEditModal.js